import apiClient from './client.js';

const base = (wsId) => `/workspaces/${wsId}/analytics`;

export const executeQuery = (wsId, spec) =>
  apiClient.post(`${base(wsId)}/query`, spec);

export const getSchema = (wsId, source) =>
  apiClient.get(`${base(wsId)}/schema${source ? `/${source}` : ''}`);
